import { Accommodation, PriceSuggestion } from '../../../routes/reducers/types';
import Price, { PriceInfo } from '../components/Price';
import { usePriceFetcher } from '../priceHooks';

function suggestionToPriceInfo(priceSuggestion: PriceSuggestion): PriceInfo {
  return {
    price: priceSuggestion.price,
    arrival: priceSuggestion.arrival,
    departure: priceSuggestion.departure,
    checkin: priceSuggestion.checkin,
    checkout: priceSuggestion.checkout,
  };
}

interface PriceContainerProps {
  accommodation?: Pick<Accommodation, 'id'>;
  renderMatchingAndAlternatives: boolean;
}

export default function PriceContainer({
  accommodation,
  renderMatchingAndAlternatives,
}: PriceContainerProps): JSX.Element | null {
  const { loading, matchingPrice, alternativePrices, hasMatchingPrice } = usePriceFetcher(
    accommodation?.id,
  );

  if (!accommodation) {
    return null;
  }

  return (
    <Price
      loading={loading}
      hasMatchingPrice={hasMatchingPrice}
      matchingPrice={matchingPrice ? suggestionToPriceInfo(matchingPrice) : null}
      alternativePrices={alternativePrices && alternativePrices.map(suggestionToPriceInfo)}
      renderMatchingAndAlternatives={renderMatchingAndAlternatives}
    />
  );
}

const defaultProps: Pick<PriceContainerProps, 'accommodation'> = {
  accommodation: undefined,
};

PriceContainer.defaultProps = defaultProps;
